import { ATTACHMENTS_PLACEMENTS } from '@savgroup-front-common/constants';
import { DocumentData } from '@savgroup-front-common/core/formatters/getDocumentNameTranslated';
import {
  ATTACHMENT_ORIGIN,
  FileAttachmentSummary,
} from '@savgroup-front-common/types';

interface AdaptControlAttachmentsToDocumentDataArgs {
  fileAttachments?: FileAttachmentSummary[];
}

export const adaptControlAttachmentsToDocumentData = ({
  fileAttachments,
}: AdaptControlAttachmentsToDocumentDataArgs): DocumentData[] => {
  return (fileAttachments || [])
    .filter(
      (fileAttachment) =>
        fileAttachment.origin === ATTACHMENT_ORIGIN.CONTROL &&
        fileAttachment.customerVisibility,
    )
    .map((fileAttachment) => ({
      ...fileAttachment,
      type: ATTACHMENTS_PLACEMENTS.CONTROL_ATTACHMENTS,
      documentName: fileAttachment.name || '',
      url: fileAttachment.downloadLink,
      attachmentId: fileAttachment.id,
    }));
};
